const swiperList = [
  {
    img: `${process.env.REACT_APP_IMAGES_URL}/Assets/Images/Businesses/MadGamers/chair.jpg`,
    title: "Razer Iskur Chair",
    link: "https://www.razer.com/gaming-chairs/razer-iskur/RZ38-02770100-R3U1",
  },
  {
    img: `${process.env.REACT_APP_IMAGES_URL}/Assets/Images/Businesses/MadGamers/kingston.jpg`,
    title: "Kingston FURY Beast",
    link: "https://www.kingston.com/en/memory/gaming/kingston-fury-beast-ddr4-rgb-memory",
  },
  {
    img: `${process.env.REACT_APP_IMAGES_URL}/Assets/Images/Businesses/MadGamers/logitech.png`,
    title: "Logitech G923 TRUEFORCE",
    link: "https://www.logitechg.com/en-us/products/driving/g923-trueforce-sim-racing-wheel.html",
  },
  {
    img: `${process.env.REACT_APP_IMAGES_URL}/Assets/Images/Businesses/MadGamers/keyboard.png`,
    title: "PLAY WITH LEGENDS",
    link: "https://www.logitechg.com/en-us/league-of-legends-collection.html",
  },
  {
    img: `${process.env.REACT_APP_IMAGES_URL}/Assets/Images/Businesses/MadGamers/controller.jpg`,
    title: "Xbox Wireless Controller",
    link: "https://www.xbox.com/en-US/accessories",
  },
  {
    img: `${process.env.REACT_APP_IMAGES_URL}/Assets/Images/Businesses/MadGamers/gpu.jpeg`,
    title: "3090 RTX Nvidia",
    link: "https://www.nvidia.com/en-me/geforce/graphics-cards/30-series/rtx-3090-3090ti/",
  },
];

export default swiperList;
